export default {
  CSV_URL: process.env.REACT_APP_CSV_URL ?? '',
  DATA_URL: process.env.REACT_APP_DATA_URL ?? '',
  DEVS_CSV_URL: process.env.REACT_APP_DEVS_CSV_URL ?? '',
  DEVS_LOC_CSV_URL: process.env.REACT_APP_DEVS_LOC_CSV_URL ?? '',
  LAST_1Y_DEVS_LOC_CSV_URL: process.env.REACT_APP_LAST_1Y_DEVS_LOC_CSV_URL ?? '',
  REPOS_CSV_URL: process.env.REACT_APP_REPOS_CSV_URL ?? '',
};